import { render } from "./About.vue?vue&type=template&id=2160ac3c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=2160ac3c&scoped=true&lang=css"

import exportComponent from "C:\\Development\\app.pdok.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160ac3c"]])

export default __exports__